(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiref400"];
var parcelRegister = parcelRequire.register;
parcelRegister("4i3nO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31fb77a86faa6314$export$2e2bcd8739ae039; });

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");

var $6CdNF = parcelRequire("6CdNF");

var $f2oEI = parcelRequire("f2oEI");

var $3eaZI = parcelRequire("3eaZI");

var $fp3uY = parcelRequire("fp3uY");

var $31fb77a86faa6314$export$2e2bcd8739ae039 = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $6CdNF._)(ProductItem, HTMLElement1);
    var _super = (0, $3eaZI._)(ProductItem);
    function ProductItem() {
        (0, $J7ygF._)(this, ProductItem);
        var _this;
        var _this_dataset, _this_dataset1;
        _this = _super.call(this);
        _this.carouselEl = _this.querySelector(".swiper");
        _this.currentSlideText = _this.querySelector(".current-slide");
        _this.isSwipeable = ((_this_dataset = _this.dataset) === null || _this_dataset === void 0 ? void 0 : _this_dataset.swipeable) === "true";
        _this.showMobileSimple = ((_this_dataset1 = _this.dataset) === null || _this_dataset1 === void 0 ? void 0 : _this_dataset1.mobileSimple) === "true";
        _this.isLargeQuery = window.matchMedia("(min-width: 1024px)").matches;
        return _this;
    }
    (0, $hvJJn._)(ProductItem, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var _this = this;
                // if show mobile simple is true, and we are on a small screen, do not initialize the carousel
                if (this.showMobileSimple && !this.isLargeQuery) return;
                // init carousel
                if (this.carouselEl) {
                    this.carousel = new (0, $fp3uY.default)(this.carouselEl, {
                        loop: true,
                        slidesPerView: 1,
                        spaceBetween: 0,
                        allowTouchMove: this.isSwipeable
                    });
                    this.carousel.on("slideChange", function() {
                        if (_this.currentSlideText && _this.carousel) _this.currentSlideText.innerHTML = _this.carousel.realIndex + 1;
                    });
                    this.prev = this.querySelector(".prev");
                    this.next = this.querySelector(".next");
                    if (this.prev) this.prev.addEventListener("click", function() {
                        _this.carousel.slidePrev();
                    });
                    if (this.next) this.next.addEventListener("click", function() {
                        _this.carousel.slideNext();
                    });
                }
            }
        }
    ]);
    return ProductItem;
}((0, $f2oEI._)(HTMLElement));

});
parcelRegister("J7ygF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $087a0fb22a93b2d1$export$71511d61b312f219; });
function $087a0fb22a93b2d1$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hvJJn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbf8ce221d4c5514$export$71511d61b312f219; });
function $cbf8ce221d4c5514$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cbf8ce221d4c5514$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("6CdNF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4d10ff170fc484d8$export$71511d61b312f219; });

var $cQvOp = parcelRequire("cQvOp");
function $4d10ff170fc484d8$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $cQvOp._)(subClass, superClass);
}

});
parcelRegister("cQvOp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $95a30497252ae948$export$71511d61b312f219; });
function $95a30497252ae948$export$71511d61b312f219(o, p) {
    $95a30497252ae948$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $95a30497252ae948$export$71511d61b312f219(o, p);
}

});


parcelRegister("f2oEI", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $af2a2b044a0a409b$export$71511d61b312f219; });

var $gLC2R = parcelRequire("gLC2R");

var $kW6rP = parcelRequire("kW6rP");

var $jDxPN = parcelRequire("jDxPN");

var $cQvOp = parcelRequire("cQvOp");
function $af2a2b044a0a409b$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $af2a2b044a0a409b$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $jDxPN._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $gLC2R._)(Class, arguments, (0, $kW6rP._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $cQvOp._)(Wrapper, Class);
    };
    return $af2a2b044a0a409b$export$71511d61b312f219(Class);
}

});
parcelRegister("gLC2R", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c34e8c1ad92e968a$export$71511d61b312f219; });

var $dT0gu = parcelRequire("dT0gu");

var $cQvOp = parcelRequire("cQvOp");
function $c34e8c1ad92e968a$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $dT0gu._)()) $c34e8c1ad92e968a$export$71511d61b312f219 = Reflect.construct;
    else $c34e8c1ad92e968a$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $cQvOp._)(instance, Class.prototype);
        return instance;
    };
    return $c34e8c1ad92e968a$export$71511d61b312f219.apply(null, arguments);
}

});
parcelRegister("dT0gu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a1c09e075e482dd9$export$71511d61b312f219; });
function $a1c09e075e482dd9$export$71511d61b312f219() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("kW6rP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f3de39cf8026604e$export$71511d61b312f219; });
function $f3de39cf8026604e$export$71511d61b312f219(o) {
    $f3de39cf8026604e$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f3de39cf8026604e$export$71511d61b312f219(o);
}

});

parcelRegister("jDxPN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e4bbe7ac69c9ab68$export$71511d61b312f219; });
function $e4bbe7ac69c9ab68$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("3eaZI", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $259b352671629a5e$export$71511d61b312f219; });

var $kW6rP = parcelRequire("kW6rP");

var $dT0gu = parcelRequire("dT0gu");

var $1d9ZF = parcelRequire("1d9ZF");
function $259b352671629a5e$export$71511d61b312f219(Derived) {
    var hasNativeReflectConstruct = (0, $dT0gu._)();
    return function _createSuperInternal() {
        var Super = (0, $kW6rP._)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $kW6rP._)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $1d9ZF._)(this, result);
    };
}

});
parcelRegister("1d9ZF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0e1ec1de7b164f64$export$71511d61b312f219; });

var $esf5j = parcelRequire("esf5j");

var $5euqn = parcelRequire("5euqn");
function $0e1ec1de7b164f64$export$71511d61b312f219(self, call) {
    if (call && ((0, $5euqn._)(call) === "object" || typeof call === "function")) return call;
    return (0, $esf5j._)(self);
}

});
parcelRegister("esf5j", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a85f61b7cff42eb9$export$71511d61b312f219; });
function $a85f61b7cff42eb9$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("5euqn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3cf5dc3c2ce8e525$export$71511d61b312f219; });
function $3cf5dc3c2ce8e525$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});




parcelRegister("5vuqB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $40277363b68668b9$export$71511d61b312f219; });
function $40277363b68668b9$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("ltnlO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fa1e6b5e4cf4e6cf$export$71511d61b312f219; });

var $5vuqB = parcelRequire("5vuqB");
function $fa1e6b5e4cf4e6cf$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5vuqB._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("1WOPg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $16b2a2272a36e4b4$export$71511d61b312f219; });
function $16b2a2272a36e4b4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $16b2a2272a36e4b4$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $16b2a2272a36e4b4$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("5ZV7E", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $45def593611ffc53$export$71511d61b312f219; });

var $dakGr = parcelRequire("dakGr");

var $3iELS = parcelRequire("3iELS");

var $lbIZx = parcelRequire("lbIZx");

var $6HNFp = parcelRequire("6HNFp");
function $45def593611ffc53$export$71511d61b312f219(arr, i) {
    return (0, $dakGr._)(arr) || (0, $3iELS._)(arr, i) || (0, $6HNFp._)(arr, i) || (0, $lbIZx._)();
}

});
parcelRegister("dakGr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $995c40d652b0553f$export$71511d61b312f219; });
function $995c40d652b0553f$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("3iELS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2672addbd595e189$export$71511d61b312f219; });
function $2672addbd595e189$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("lbIZx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f6cd8669e12714d8$export$71511d61b312f219; });
function $f6cd8669e12714d8$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("6HNFp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4e1d490ad7b9bee1$export$71511d61b312f219; });

var $84Wdk = parcelRequire("84Wdk");
function $4e1d490ad7b9bee1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $84Wdk._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $84Wdk._)(o, minLen);
}

});
parcelRegister("84Wdk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5e1bda8aa9cfef6d$export$71511d61b312f219; });
function $5e1bda8aa9cfef6d$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



})();
//# sourceMappingURL=ProductItem.fe7214a2.js.map
